define('models/conversation/conversation',[
    'underscore', 'backbone', 'utils',
    // services
    'services/api',
    'services/user',
    // mixins
    'mixins/general/query-params-mixin',
    // models & collections
    'src/file-upload-model',
    'collections/conversation/messages',
    'models/member/profile'
], function(
    _, Backbone, U,
    // services
    API,
    User,
    // mixins
    QueryParamsMixin,
    // models & collections
    FileUploadModel,
    CMessages,
    MProfile
) {

    var MConversation = FileUploadModel.extend(_.extend({
        idAttribute: "_id",

        queryParams: {
            groupConversation: false,
            limit: 5,
            skip: function() {
                return this.messagesCount || this.getMessages().length;
            },
        },

        urlRoot: function() {
            return API.url('conversations/');
        },

        url: function() {
            var url = MConversation.__super__.url.apply(this, arguments);

            if (this.parentMessageId) {
                url = url + '/message/' + this.parentMessageId;
            }

            if (this.distantMemberId) {
                url = url + '/user/' + this.distantMemberId;
            }

            return url;
        },

        urlDestroy: function()
        {
            return MConversation.__super__.url.apply(this, arguments);
        },

        markAsUnread: function(options) {
            this.folder = null;

            options = _.extend(options, {
                url: API.url('conversations/' + this.id + '/markUnread/')
            });

            return this.sync("patch", this, options);
        },

        markAsRead: function(options) {
            this.folder = null;

            opts = _.extend(options, {
                url: API.url('conversations/markRead/' + this.id)
            });

            return this.sync("patch", this, opts);
        },

        files: ['attachments'],
        defaults: {
            lastMessageDate: null,
            subject: "",
            sendNotification: true,
        },

        sync: function(method, model, options) {
            if (options.type === 'POST') { method = "create"; }
            MConversation.__super__.sync.call(this, method, model, options);
        },

        parse: function(data) {
            if (data.messages && data.messages.length > 0) {
                var message = _.last(data.messages);
                _.extend(data, { lastMessageDate: message.date });
            }
            return MConversation.__super__.parse.call(this, data);
        },

        hasUser: function(userId) {
            var users = this.getUsers();

            if (userId === User.id) {
                return _.indexOf(users, userId) > -1 && users.length === 1;
            } else {
                return _.indexOf(users, userId) > -1 && _.indexOf(users, User.id) > -1;
            }
        },

        isRead: function() {
            var usersRead = this.get("read");

            return _.indexOf(usersRead, User.id) > -1;
        },

        setAsRead: function() {
            var usersRead = this.get("read");
            if (!usersRead || _.indexOf(usersRead, User.id) > -1) return;

            usersRead.push(User.id);
            this.set("read", usersRead);
            this.save(null);
        },

        setDistantMember: function(distantMemberId) {
            this.distantMemberId = distantMemberId;
            return this;
        },

        getLastMessage: function() {
            return _.last(this.getMessages());
        },

        getMessages: function(opt) {
            opt = opt || {};
            var messages = _.map(this.get('messages'), function(messageObj) {
                messageObj.conversation = this.id;
                return messageObj;
            }, this);
            return opt.collection ? new CMessages(messages) : messages;
        },

        getMostRecentMessage: function() {
            return _.first(this.getMessages());
        },

        getUser: function() {
            var user = this.getUsersWithoutMe(),
                computedUsers = this.getComputedUsers();
            return computedUsers ? new MProfile(computedUsers[_.isEmpty(user) ? User.id : user]) : User;
        },

        getDisplayName: function() {
            return this.getUser().get('displayName');
        },

        getUsersWithoutMe: function() {
            return _.without(this.getUsers(), User.id);
        },

        getUsers: function() {
            return this.get('users');
        },

        getComputedUsers: function() {
            return this.get('_users');
        },

        addMessage: function(message) {
            this.set('message', message);
        },

        setUser: function(userId) {
            return this.set('users', [userId]);
        },

        resetParentMessageId: function() {
            this.parentMessageId = undefined;
        },

        resetDistantMemberId: function() {
            this.distantMemberId = undefined;
        },

        save: function(attrs, opt) {
            opt = opt || {};
            if (opt.markAsRead) this.markAsRead = opt.markAsRead;
            if (opt.parentMessageId) this.parentMessageId = opt.parentMessageId;
            return MConversation.__super__.save.apply(this, [attrs, opt]);
        },

        fetch: function(options) {
            options = options || {};
            var data = options.data || {},
                url = options.url || _.result(this, 'url') || Backbone.Extension.urlError(),
                state = this.state;

            if (options.messagesCount) {
                this.messagesCount = options.messagesCount;
            }

            // dedup query params
            var queryStringIndex = url.indexOf('?');
            if (queryStringIndex > -1) {
                data = _.extend({}, data, this.queryStringToParams(url.slice(queryStringIndex + 1)));
                url = url.slice(0, queryStringIndex);
            }

            options.url = url;

            // map the query params to the data object used by the underlying ajax lib
            // to construct the query string
            options.data = this.getQueryStringData(data);

            return MConversation.__super__.fetch.call(this, options);
        },

        destroy: function (options)
        {
            return Backbone.Model.prototype.destroy.call(this, _.extend({url: this.urlDestroy()}, options));
        },

        firstFetch: function(opt) {
            opt = _.extend({ fetch: true, reset: true }, opt);
            if (opt.reset) {
                this.messagesCount = 0;
                this.set('messages', null);
            }
            return this.fetch(opt);
        },
    }, QueryParamsMixin));

    // Return the model for the module
    return MConversation;
});

